<template>
    <div>
        <b-modal
            id="boardingFormPrint"
            ref="boardingFormPrint"
            :lazy="true"
            title-tag="h2"
            title="Print Form"
        >
            <div v-if="message" class="alert alert-warning" role="alert">
                <i class="cus-error"></i>
                {{ message }}
            </div>
            <b-form-group
                :label-for="`start`"
                label="Checking Date:"
                label-cols="3"
            >
                <date-picker
                    :config="datePickerOptions"
                    @dp-change="dateChange($event, 'start')"
                    :value="data.start"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('start') }"
                    class="form-control"
                    name="start"
                ></date-picker>
            </b-form-group>
            <b-form-group
                label="Form:"
                class
                label-cols="3"
                label-for="letter_id"
            >
                <v-select
                    id="letter_id"
                    ref="letter_id"
                    :options="templates"
                    v-model="data.letter_id"
                    v-validate="'required'"
                    :reduce="template => template.id"
                    :class="{ 'border-danger': errors.has('letter_id') }"
                    name="letter_id"
                    placeholder="Select template (required)"
                    label="name"
                />
            </b-form-group>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.boardingFormPrint.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="print" v-else variant="primary"
                        >Print</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import vSelect from "vue-select";
export default {
    components: {
        vSelect
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            loading: false,
            setting: {},
            data: {
                start: moment(),
                letter_id: null
            },
            templates: [],
            message: "",
            datePickerOptions: {
                format: "DD/MM/YYYY"
            }
        };
    },
    mounted() {
        this.data.start = moment().tz(this._timeZone);
    },
    methods: {
        open(date) {
            this.getTemplate().then(templates => {
                this.getBoardingSetting().then(setting => {
                    this.data.letter_id = setting.letter_id;
                });
            });

            this.datePickerOptions.format = this.getDateFormat();

            if (date) {
                this.data.start = date;
            }

            this.$refs["boardingFormPrint"].show();
        },
        getTemplate() {
            let self = this;
            return this.$http
                .get(process.env.ACCOUNT_SERVICE + "template/letter")
                .then(function (response) {
                    self.templates = response.data.response.resources;
                    return self.templates;
                });
        },
        async getBoardingSetting() {
            let response = await this.$http.get(
                process.env.SCHEDULE_SERVICE + "boarding/setting"
            );
            if (response) {
                this.setting = response.data.response.resource;
            }
            return this.setting;
        },
        isVetterPrintEnabled() {
            return this._isExtensionEnabled("VETTER_PRINTER");
        },
        dateChange(event, element) {
            this.data[element] = event.date;
        },
        async print() {
            this.loading = true;
            this.message = false;

            try {
                const valid = await this.$validator.validateAll();

                if (!valid) {
                    return false;
                }

                let post = {
                    start: moment(this.data.start).format(
                        this.datePickerOptions.format
                    ),
                    letter: this.data.letter_id
                };

                const response = await $.post(
                    process.env.APPS +
                        "index.php/schedule/boarding/exportBoardingForm",
                    post
                );
                if (response.state == 0) {
                    this.$refs["boardingFormPrint"].hide();
                    if (response.path) {
                        this._redirect(response.path, true, 500);
                    }
                } else {
                    this.message = response.message;
                }
            } catch (error) {
                this.loading = false;
                throw error;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
